module.exports = __webpack_public_path__ + "static/media/om_hairstyle_loose_front_vector.4465beb5.svg";